import React, { useEffect } from 'react';
import { Grid, Tooltip, Paper, Box, Divider } from '@mui/material';
import { FANTASY_COLORS } from '../constants/gameConstants';
import { fantasyTheme } from '../theme/fantasyTheme';
const theme = fantasyTheme;

const ColorSelector = ({ selectedColor, setSelectedColor }) => {

  useEffect(() => {
    if (!selectedColor) {
      setSelectedColor(FANTASY_COLORS[0].color);
    }
  }, [selectedColor, setSelectedColor]);

  return (
    <Box>
        <Divider sx={{ my: 1 }}>Colors</Divider>
        <Grid container spacing={1.5}>
            {FANTASY_COLORS.map(({ color, name }) => (
            <Grid item key={color}>
            <Tooltip title={name} arrow>
                <Paper
                onClick={() => setSelectedColor(color)}
                sx={{
                    width: 45,
                    height: 45,
                    backgroundColor: color,
                    cursor: 'pointer',
                    borderRadius: '50%',
                    opacity: selectedColor === color ? 1 : 0.5,
                    border: selectedColor === color ? `3px solid ${theme.palette.secondary.light}` : `2px solid ${theme.palette.background.main}`,
                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.3), inset 0 2px 4px rgba(255, 255, 255, 0.3)',
                    position: 'relative',
                    overflow: 'hidden',
                    '&:hover': {
                    transform: 'scale(1.1) rotate(5deg)',
                    transition: 'all 0.3s ease',
                    boxShadow: '0 6px 12px rgba(0, 0, 0, 0.4), inset 0 2px 4px rgba(255, 255, 255, 0.4)',
                    },
                    '&::after': {
                    content: '""',
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    borderRadius: '50%',
                    }
                }}
                />
            </Tooltip>
            </Grid>
        ))}
        </Grid>
    </Box>
  );
};

export default ColorSelector; 